module.exports = __webpack_public_path__ + "static/media/BlurbTop.f0b54c64.png";